import { useQuery } from '@tanstack/react-query';
import axios from '../axios';
import { GetFeaturesResponse } from '@aaa-ncnu-ie/mypolicy-api-features';

export const getFeatures = async () => {
  const { data } = await axios.get<GetFeaturesResponse>(
    `${import.meta.env.VITE_FEATURES_URL}/v1/features`
  );

  return data;
};

export const useGetFeaturesQuery = (enabled: boolean = false) =>
  useQuery({
    queryKey: ['features'],
    queryFn: () => getFeatures(),
    staleTime: 1000 * 60 * 60,
    enabled,
  });
